<template>
<v-card>
  <v-fab-transition>
    <v-btn
      @click='$emit("save", invoice)'
      v-show='dirty'
      :loading='loading'
      fab bottom left fixed
      color='success' >
      <v-icon >save</v-icon>
    </v-btn>
  </v-fab-transition >
  <v-card-text >
    <v-layout row wrap >
      <v-flex xs12 sm6 order-xs2 order-sm1 >
        <img
          v-if='practitioner.logo_picture'
          :src='practitioner.logo_picture'
          class='mt-4 hidden-xs-only' style='max-height:200px; max-width:400px' />
        <v-alert :value='true' type='info' v-else >
          Looks like you haven't updated a logo.
          <v-btn icon dark
            v-if='spaceSettings'
            :href='spaceSettings'
            :disabled='!rolesIsOwnerOfSpace(spaceId)'
            target='_blank' >
            <v-icon>open_in_new</v-icon>
          </v-btn>
          <!-- <v-btn to='/settings/media' flat >
            Add a logo to my profile </v-btn> -->
          <v-btn :href=''
        </v-alert>
        <v-list>
          <v-subheader
            v-if='practitioner.practice_name || practitioner.practice_number'
            class='ml-0 pl-0 pb-0' >Business details:</v-subheader>
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title v-if='practitioner.practice_name' >
                <strong>
                  <span v-if='practitioner.practice_number' >Practice</span>
                  <span v-else >Business</span>
                  name:
                </strong>
                {{practitioner.practice_name}}
              </v-list-tile-title>

              <v-list-tile-sub-title v-if='practitioner.practice_number' >
                <strong>Practice number:</strong>
                {{practitioner.practice_number}}
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <!-- <v-btn @click='launchInvoiceSettingsDialog({spaceId})' > -->
              <v-btn
                v-if='spaceSettings'
                :href='spaceSettings'
                :disabled='!rolesIsOwnerOfSpace(spaceId)'
                target='_blank' icon>
                <v-icon>edit</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex xs12 sm6 order-xs1 order-sm2 >
        <date-picker-dialog close-on-change v-model='invoice.date' label='Invoice date' ></date-picker-dialog>
        <date-picker-dialog close-on-change v-model='invoice.due_date' label='Due date' ></date-picker-dialog>
      </v-flex>

      <v-flex xs12 sm6 order-xs3 order-sm3 >
        <v-subheader class='ml-0 pl-0 pb-0' >Invoiced by:</v-subheader>
        <v-textarea box auto-grow
          v-model='invoice.billing_address'
          :persistent-hint='true'
          hint='Editing this value will only change the details for this invoice. To update the billing address for new invoices, click "Edit billing address"'
          class='mb-0' ></v-textarea>
        <!-- <v-layout>
          <v-spacer></v-spacer>
          <v-btn flat style='margin-top:-15px;'
            @click="launchInvoiceSettingsDialog({touch: Math.random()})" >
            Edit billing address
          </v-btn>
        </v-layout> -->
      </v-flex>
      <v-flex xs12 sm6 order-xs4 order-sm4 >
        <v-subheader class='ml-0 pl-0 pb-0' >Customer details:</v-subheader>
        <v-textarea
          box auto-grow
          v-model='invoice.invoicee_details' >
        </v-textarea>

        <v-checkbox v-model='invoice.integrate_medical_aid' label='Include medical aid details' ></v-checkbox>
        <v-textarea box v-if='invoice.integrate_medical_aid' v-model='invoice.medicalaid_details' label="Medical aid details:" ></v-textarea>

      </v-flex>
    </v-layout>
    <v-toolbar class='mb-2 mt-4' dark flat dense >
      <v-btn
        :loading='enriching'
        @click='enrich(invoice.appointments)'
        icon ><v-icon>replay</v-icon></v-btn>
      <v-toolbar-title >Lineitems</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn
        :icon='$vuetify.breakpoint.xs'
        @click = "launchAppointmentPicker({initialClient: invoice.client_data, initialAppointments: invoice.appointments}, {'selected': enrich})" >
          <v-icon>edit</v-icon><span class='hidden-xs-only' >Edit appointments</span></v-btn> -->
    </v-toolbar>
    <template v-for='appointment in invoice.appointment_data'>
    <v-card class='mt-2' :key='appointment.id' >
      <v-layout class='pa-1' row >
        <v-flex class='pt-3 pl-2 subheading' xs3 >{{appointment.invoice_title || appointment.title || appointment.full_name}}</v-flex>
        <v-flex class='pt-3' xs3>{{dateformat(appointment.start_time)}}</v-flex>
        <v-flex class='text-xs-right pt-3' xs3>{{formatCurrency(invoice.currency, appointment.price)}}
        </v-flex>
        <v-flex class='text-xs-right' xs3 >
          <v-btn
            @click="openGlobalDialog(true, 'InvoiceDetails', { appointment: appointment, touch: Math.random() })"
            icon small ><v-icon>edit</v-icon></v-btn>
        </v-flex>
      </v-layout>
      <v-divider :key='appointment.start_time' ></v-divider>
      <v-card flat v-if='appointment.codes && appointment.codes.length > 0' >
        <h3 class='subheading ml-3 mt-2' :key='appointment.end_time' >Sub-items</h3>
        <template v-for='code in appointment.codes' >
          <v-layout row :key='code.id' >
            <v-divider :key='code.process_code' ></v-divider>
            <v-flex class='pt-3 pl-4' xs3>{{code.icd10}}</v-flex>
            <v-flex class='pt-3' xs3>{{code.process}}</v-flex>
            <v-flex class='text-xs-right pt-3' xs3>{{formatCurrency(invoice.currency, code.price)}}
            </v-flex>
            <v-flex class='text-xs-right' xs3 >
              &nbsp;
              <!-- <v-btn icon small ><v-icon>edit</v-icon></v-btn>
              <v-btn icon small ><v-icon>delete</v-icon></v-btn> -->
            </v-flex>
          </v-layout>
          <v-divider :key='code.process' ></v-divider>
        </template>
      </v-card>
    </v-card>
    </template>
    <v-card-actions>
        <v-icon>info</v-icon>
        Appointments are saved on the invoice when created.
        To update the appointments as they appear on this invoice
        you will need to
        <v-spacer/>
        <v-btn flat
          :loading='enriching' :icon='$vuetify.breakpoint.xs'
          @click='enrich(invoice.appointments)' >
          <v-icon>replay</v-icon>
          <span class='hidden-xs-only' >Refresh Appointments</span>
        </v-btn>
    </v-card-actions>

    <v-layout row wrap >
      <v-flex xs12 sm6 >
        <v-subheader class='ml-0 pl-0 pb-0' >Notes:</v-subheader>
        <v-textarea v-model='invoice.notes' box ></v-textarea>
      </v-flex>

      <v-spacer></v-spacer>
      <v-flex xs12 sm6 class='text-xs-right' >
        <v-subheader class='ml-0 pl-0 pb-0' >Banking details:</v-subheader>
        <v-textarea
          box
          v-model='invoice.banking_details' class='mb-0 pb-0' >
        </v-textarea>
        <v-btn small flat
          to='/settings/profile'
          style='margin-top:-20px;' >Edit banking details</v-btn>
      </v-flex>
    </v-layout>
  </v-card-text>
</v-card>
</template>

<script>
import DatePickerDialog from '@/components/pickers/DatePickerDialog'
import {LINKS} from '@/store/constants.js'
import axios from 'axios'
import Vue from 'vue'

export default {
  name: 'InvoiceDetail',
  components: {DatePickerDialog},
  props: {
    value: { type: Object, default: () => { return {} } },
    loading: { type: Boolean, default: false }
  },
  data () {
    return {
      api: this.$invoiceguru,
      resource: 'invoices',
      enriching: false,
      invoice: {},
      dirty: false,
      enrichReqId: 'enrich-invoice-request'
    }
  },
  mounted () {
    if (this.value) {
      this.invoice = this.value
    }
  },
  watch: {
    value () {
      if (this.value) {
        this.invoice = this.value
      }
    },
    invoice () {
      this.dirty = true
      this.$emit('input', this.invoice)
    }
  },
  computed: {
    spaceSettings () {
      if (this.spaceId) {
        return LINKS.SETTINGS + '#/settings/spaces/' + this.spaceId
      }
    },
    invoiceId () {
      if (this.invoice) {
        return this.invoice.id
      }
    },
    spaceId () {
      return this.getObjectPath(this.invoice, 'space_id')
    },
    practitioner () {
      if (this.invoice) {
        return this.getObjectPath(this.invoice, 'practitioner_data', {})
      }
      return {}
    },
    appointmentIds () {
      return this.invoice.appointments.join(',')
    }
  },
  methods: {
    deleteInvoice (id) {
      this.api
        .resource(this.resource)
        .delete(id)
    },
    enrich (appointmentIds) {
      if (appointmentIds) {
        this.invoice.appointments = appointmentIds
      }
      let vm = this
      let base = this.$invoiceguru.baseUrl
      let headers = this.$invoiceguru.headers
      let url = `${base}/invoices/${this.invoice.id}/enrich/`
      let params = {
        'appointments': this.appointmentIds
      }
      vm.enriching = true
      axios.post(url, params, {headers})
        .then((response) => {
          // vm.invoice = response.data
          Vue.set(vm.invoice, response.data)
          vm.$emit('input', response.data)
          vm.$emit('refresh')
          vm.enriching = false
        })
        .catch(() => {
          vm.enriching = false
        })

      this.$store.dispatch('HIDE_SPACE', 'globalDialog')
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// InvoiceDetail.vue?473509fc